<div class="wrapper" [ngClass]="{ transparent: transparent(), inline: inline() }">
  <div>
    <p class="amount">
      @if (amount() < 100) {
        {{ amount() }}
      } @else {
        99+
      }
    </p>
  </div>
</div>
